import { floor } from 'lodash/fp';
export var floor2 = floor.convert({
  fixed: false
});
export default floor2;